module.exports = __webpack_public_path__ + "img/BibleStudyBG.bafd323d.jpg";